export const removeDuplicates = (list) => [...new Set(list)];
//# sourceMappingURL=common.js.map